import { CurrencyEnum } from "@finway-group/shared/lib/models"
import { Button, Card, Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { CubeIcon, RocketIcon } from "Components/icons"
import { IconBackground } from "Components/icons/iconBackground"
import PriceLabel from "Components/priceLabel"

interface PaymentSubscriptionUpdateCardInterface {
    spanIcon: number
    spanName: number
    name: string
    unitPrefixText: string
    units: number
    spanPrice?: number
    isPriceAvailable: boolean
    price?: {
        amount: number
        currency: CurrencyEnum
    }
    spanButton: number
    isButtonVisible?: boolean
    buttonText: string
    onClick: () => void
    isButtonDisabled?: boolean
}

const PaymentSubscriptionUpdateCard: React.FC<PaymentSubscriptionUpdateCardInterface> = ({
    spanIcon,
    spanName,
    name,
    unitPrefixText,
    units,
    spanPrice = 0,
    isPriceAvailable,
    price,
    spanButton,
    isButtonVisible = true,
    buttonText,
    onClick,
    isButtonDisabled = false,
}) => {
    const { t } = useTranslation()

    return (
        <Card>
            <Row align="middle">
                <Col span={spanIcon}>
                    <IconBackground>
                        <CubeIcon />
                    </IconBackground>
                </Col>
                <Col span={spanName}>
                    <p className="text-lg text-primary truncate">{name}</p>
                    <p className="text-gray-900 truncate">
                        <span>{unitPrefixText}</span>
                        <span className="font-semibold ml-4 mr-4">{units}</span>
                        <span>{t("input:payment_settings.monthly_invoices")}</span>
                    </p>
                </Col>
                {isPriceAvailable && (
                    <Col span={spanPrice} className="flex justify-end">
                        <p className="text-2xl text-primary font-semibold">
                            {price ? ( // in case Price is missing in Stripe
                                <PriceLabel value={price.amount / 100} currency={price.currency} showFullNumber />
                            ) : (
                                <>{t("label:payment_settings.price_tba")}</>
                            )}
                        </p>
                    </Col>
                )}
                {isButtonVisible && (
                    <Col span={spanButton} className="flex justify-end">
                        <Button icon={<RocketIcon />} className="ant-btn btn-highlight-green-active" onClick={onClick} disabled={isButtonDisabled}>
                            {t(buttonText)}
                        </Button>
                    </Col>
                )}
            </Row>
        </Card>
    )
}

export default PaymentSubscriptionUpdateCard
